import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import React from 'react';
import { CredentialAndStatus } from '../DialogComponents/CredentialAndStatus';
import { ExceptionDetails } from '../DialogComponents/ExceptionDetails/ExceptionDetails';
import { IRequirementType } from '../DialogComponents/models/PlacementDialogModels';
import { ViewExceptionWaive } from '../DialogComponents/ViewExceptionWaive';

const useStyles = makeStyles()({
  form: {
    minWidth: '800px',
  },
  textColor: {
    paddingTop: 8,
    paddingLeft: 0,
    color: '#707070',
  },
  spacing: {
    margin: '10px 0px',
    width: '100%',
  },
});

export const MarkExceptionContent = props => {
  const { classes } = useStyles();
  return (
    <LayoutGrid className={classes.form}>
      {props.edit || props.add ? (
        <React.Fragment>
          <LayoutGridItem xs={12} className={classes.spacing}>
            <Typography
              variant="body1"
              className={classes.textColor}
            >{`Fields marked with an asterisk (*) are required.`}</Typography>
          </LayoutGridItem>
          <LayoutGridItem xs={12} className={classes.spacing}>
            <CredentialAndStatus
              credentialName={props.credentialName || '-'}
              type={IRequirementType.markException}
              isChanged={props.isChanged}
              {...props}
            />
          </LayoutGridItem>
          <LayoutGridItem xs={12}>
            <ExceptionDetails isChanged={props.isChanged} selectedStatusType={props.selectedStatusType} />
          </LayoutGridItem>
        </React.Fragment>
      ) : (
        <LayoutGridItem xs={12}>
          <ViewExceptionWaive credentialName={props.credentialName || '-'} />
        </LayoutGridItem>
      )}
    </LayoutGrid>
  );
};
